import TelesoftSyncManager from './TelesoftSyncManager.js';

// Singleton pattern to prevent duplicate instances
let instance = null;

export default class TelesoftSyncChargeManager {
  constructor() {
    // Return existing instance if it exists
    if (instance) {
      return instance;
    }
    
    this.telesoftSync = new TelesoftSyncManager();
    this.currentOrderId = null;
    this.entitySynced = false;
    this.productSynced = false;
    this.eventsInitialized = false;
    this.bindEvents();
    
    // Store this instance
    instance = this;
    return instance;
  }

  bindEvents() {
    // Prevent duplicate event binding
    if (this.eventsInitialized) {
      return;
    }
    this.eventsInitialized = true;

    // Handle modal opening for multi-step sync
    $(document).on('click', '.telesoft-sync-charge-btn', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const orderId = $(e.currentTarget).data('order-id');
      this.initializeModal(orderId);
    });

    // Handle modal show events
    $(document).on('show.bs.modal', '[id^="telesoft-sync-charge-modal-"]', (e) => {
      const modal = $(e.target);
      const orderId = modal.data('order-id');
      this.currentOrderId = orderId;
      this.resetModalState(orderId);
      this.startInitialCheck(orderId);
    });

    // Handle sync entity button
    $(document).on('click', '[id^="sync-entity-btn-"]', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const orderId = $(e.target).data('order-id');
      this.syncEntity(orderId);
    });

    // Handle sync product button
    $(document).on('click', '[id^="sync-product-btn-"]', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const orderId = $(e.target).data('order-id');
      this.syncProduct(orderId);
    });

    // Handle next step button
    $(document).on('click', '[id^="next-step-btn-"]', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const orderId = $(e.target).data('order-id');
      this.goToNextStep(orderId);
    });

    // Handle create charge button
    $(document).on('click', '[id^="create-charge-btn-"]', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const orderId = $(e.target).data('order-id');
      this.createCharge(orderId);
    });
  }

  initializeModal(orderId) {
    this.currentOrderId = orderId;
    this.entitySynced = false;
    this.productSynced = false;
    $(`#telesoft-sync-charge-modal-${orderId}`).modal('show');
  }

  resetModalState(orderId) {
    // Hide all steps
    $(`#telesoft-sync-charge-modal-${orderId} .sync-step`).hide();
    
    // Show initial check step
    $(`#step-initial-check-${orderId}`).show();
    
    // Reset button states
    $(`#modal-cancel-btn-${orderId}`).show().text('Annuler');
    $(`#modal-close-btn-${orderId}`).hide();
    $(`#sync-entity-btn-${orderId}`).hide().prop('disabled', false);
    $(`#sync-product-btn-${orderId}`).hide().prop('disabled', false);
    $(`#next-step-btn-${orderId}`).hide();
    $(`#create-charge-btn-${orderId}`).hide().prop('disabled', false);

    // Reset sub-states
    $(`#entity-sync-initial-${orderId}`).show();
    $(`#entity-sync-processing-${orderId}`).hide();
    $(`#entity-sync-success-${orderId}`).hide();
    $(`#entity-sync-error-${orderId}`).hide();

    $(`#product-sync-initial-${orderId}`).show();
    $(`#product-sync-processing-${orderId}`).hide();
    $(`#product-sync-success-${orderId}`).hide();
    $(`#product-sync-error-${orderId}`).hide();
  }

  startInitialCheck(orderId) {
    const modal = $(`#telesoft-sync-charge-modal-${orderId}`);
    const checkUrl = modal.data('check-readiness-url');

    $.ajax({
      url: checkUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      contentType: 'application/json'
    })
    .done((data) => {
      if (data.success) {
        this.handleInitialCheckResult(orderId, data);
      } else {
        this.showFinalError(orderId, data.error || 'Erreur lors de la vérification des prérequis');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error checking TeleSoft readiness:', error);
      this.showFinalError(orderId, 'Erreur lors de la vérification des prérequis TeleSoft');
    });
  }

  handleInitialCheckResult(orderId, data) {
    const entityExists = data.entity.exists;
    const productExists = data.product.exists;

    this.entitySynced = entityExists;
    this.productSynced = productExists;

    if (!entityExists) {
      // Need to sync entity first
      this.showEntitySyncStep(orderId);
    } else if (!productExists) {
      // Entity exists, but need to sync product
      this.showProductSyncStep(orderId);
    } else {
      // Both exist, go directly to charge creation
      this.showChargeCreationStep(orderId);
    }
  }

  showEntitySyncStep(orderId) {
    $(`#step-initial-check-${orderId}`).hide();
    $(`#step-entity-sync-${orderId}`).show();
    
    // Show sync entity button
    $(`#sync-entity-btn-${orderId}`).show();
  }

  syncEntity(orderId) {
    // Show processing state
    $(`#entity-sync-initial-${orderId}`).hide();
    $(`#entity-sync-processing-${orderId}`).show();
    $(`#sync-entity-btn-${orderId}`).prop('disabled', true);

    const modal = $(`#telesoft-sync-charge-modal-${orderId}`);
    const syncUrl = modal.data('sync-entity-url');

    $.ajax({
      url: syncUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      contentType: 'application/json'
    })
    .done((data) => {
      if (data.success) {
        this.showEntitySyncSuccess(orderId);
        this.entitySynced = true;
      } else {
        this.showEntitySyncError(orderId, data.error || 'Erreur inconnue lors de la synchronisation');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing entity:', error);
      this.showEntitySyncError(orderId, 'Erreur lors de la synchronisation de l\'entité');
    });
  }

  showEntitySyncSuccess(orderId) {
    $(`#entity-sync-processing-${orderId}`).hide();
    $(`#entity-sync-success-${orderId}`).show();
    
    // Hide sync button, show next step button
    $(`#sync-entity-btn-${orderId}`).hide();
    $(`#next-step-btn-${orderId}`).show();
  }

  showEntitySyncError(orderId, errorMessage) {
    $(`#entity-sync-processing-${orderId}`).hide();
    $(`#entity-sync-error-${orderId}`).show();
    $(`#entity-sync-error-message-${orderId}`).text(errorMessage);
    
    // Re-enable sync button
    $(`#sync-entity-btn-${orderId}`).prop('disabled', false);
  }

  showProductSyncStep(orderId) {
    $(`#step-initial-check-${orderId}`).hide();
    $(`#step-entity-sync-${orderId}`).hide();
    $(`#step-product-sync-${orderId}`).show();
    
    // Show sync product button
    $(`#sync-product-btn-${orderId}`).show();
    $(`#next-step-btn-${orderId}`).hide();
  }

  syncProduct(orderId) {
    // Show processing state
    $(`#product-sync-initial-${orderId}`).hide();
    $(`#product-sync-processing-${orderId}`).show();
    $(`#sync-product-btn-${orderId}`).prop('disabled', true);

    const modal = $(`#telesoft-sync-charge-modal-${orderId}`);
    const syncUrl = modal.data('sync-product-url');

    $.ajax({
      url: syncUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      contentType: 'application/json'
    })
    .done((data) => {
      if (data.success) {
        this.showProductSyncSuccess(orderId);
        this.productSynced = true;
      } else {
        this.showProductSyncError(orderId, data.error || 'Erreur inconnue lors de la synchronisation');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing product:', error);
      this.showProductSyncError(orderId, 'Erreur lors de la synchronisation du produit');
    });
  }

  showProductSyncSuccess(orderId) {
    $(`#product-sync-processing-${orderId}`).hide();
    $(`#product-sync-success-${orderId}`).show();
    
    // Hide sync button, show next step button
    $(`#sync-product-btn-${orderId}`).hide();
    $(`#next-step-btn-${orderId}`).show();
  }

  showProductSyncError(orderId, errorMessage) {
    $(`#product-sync-processing-${orderId}`).hide();
    $(`#product-sync-error-${orderId}`).show();
    $(`#product-sync-error-message-${orderId}`).text(errorMessage);
    
    // Re-enable sync button
    $(`#sync-product-btn-${orderId}`).prop('disabled', false);
  }

  goToNextStep(orderId) {
    if (!this.entitySynced) {
      // Should not happen, but just in case
      this.showEntitySyncStep(orderId);
    } else if (!this.productSynced) {
      this.showProductSyncStep(orderId);
    } else {
      this.showChargeCreationStep(orderId);
    }
  }

  showChargeCreationStep(orderId) {
    $(`#step-initial-check-${orderId}`).hide();
    $(`#step-entity-sync-${orderId}`).hide();
    $(`#step-product-sync-${orderId}`).hide();
    $(`#step-charge-creation-${orderId}`).show();
    
    // Check if charge creation is possible by looking for configuration errors
    const hasConfigErrors = $(`#step-charge-creation-${orderId} .bg-danger`).length > 0;
    
    if (hasConfigErrors) {
      // Configuration is incomplete, disable charge creation
      $(`#next-step-btn-${orderId}`).hide();
      $(`#create-charge-btn-${orderId}`).hide();
      $(`#modal-cancel-btn-${orderId}`).text('Fermer');
    } else {
      // Configuration is complete, show create charge button
      $(`#next-step-btn-${orderId}`).hide();
      $(`#create-charge-btn-${orderId}`).show();
    }
  }

  createCharge(orderId) {
    // Show processing state
    $(`#step-charge-creation-${orderId}`).hide();
    $(`#step-charge-processing-${orderId}`).show();
    $(`#create-charge-btn-${orderId}`).prop('disabled', true);
    $(`#modal-cancel-btn-${orderId}`).hide();

    // Get form data and URL
    const form = $(`#charge-creation-form-${orderId}`);
    const formData = form.serialize();
    
    // Get the URL from the modal's data attribute instead of form action
    const modal = $(`#telesoft-sync-charge-modal-${orderId}`);
    const createChargeUrl = modal.data('create-charge-url');

    console.log("Creating charge with data:", formData);
    console.log("Using URL:", createChargeUrl);

    $.ajax({
      url: createChargeUrl,
      method: 'PUT',
      data: formData,
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
    .done((data) => {
      console.log("Charge creation response:", data);
      if (data.success) {
        this.showFinalSuccess(orderId);
        
        // Redirect to the appropriate page after a delay
        setTimeout(() => {
          if (data.redirect_url) {
            window.location.href = data.redirect_url;
          } else {
            window.location.reload();
          }
        }, 2000);
      } else {
        this.showFinalError(orderId, data.error || 'Erreur lors de la création de la charge');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error creating charge:', error);
      console.error('XHR response:', xhr.responseText);
      
      let errorMessage = 'Erreur lors de la création de la charge';
      
      if (xhr.responseJSON && xhr.responseJSON.error) {
        errorMessage = xhr.responseJSON.error;
      } else if (xhr.responseText) {
        // Try to parse error from HTML response
        const $html = $(xhr.responseText);
        const flashError = $html.find('.alert-danger').text().trim();
        if (flashError) {
          errorMessage = flashError;
        } else {
          errorMessage = `Erreur serveur: ${xhr.status}`;
        }
      }
      
      this.showFinalError(orderId, errorMessage);
    });
  }

  showFinalSuccess(orderId) {
    $(`#step-charge-processing-${orderId}`).hide();
    $(`#step-final-success-${orderId}`).show();
    
    // Show close button
    $(`#modal-close-btn-${orderId}`).show();
    $(`#create-charge-btn-${orderId}`).hide();
  }

  showFinalError(orderId, errorMessage) {
    // Hide all steps and show error
    $(`#telesoft-sync-charge-modal-${orderId} .sync-step`).hide();
    $(`#step-final-error-${orderId}`).show();
    $(`#final-error-message-${orderId}`).text(errorMessage);
    
    // Show close button
    $(`#modal-cancel-btn-${orderId}`).hide();
    $(`#modal-close-btn-${orderId}`).show();
    $(`#create-charge-btn-${orderId}`).hide();
  }

  onDestroy() {
    // Clean up event listeners if needed
    $(document).off('click', '.telesoft-sync-charge-btn');
    $(document).off('show.bs.modal', '[id^="telesoft-sync-charge-modal-"]');
    $(document).off('click', '[id^="sync-entity-btn-"]');
    $(document).off('click', '[id^="sync-product-btn-"]');
    $(document).off('click', '[id^="next-step-btn-"]');
    $(document).off('click', '[id^="create-charge-btn-"]');
  }
}